// import TestModel from "../viewModel/testModel";
// const testModel = new TestModel();
import update from 'immutability-helper'

//  数据模型
import Model from "../viewModel";
export const antDemo = {
  name: "antDemo",
  state: {},
  reducers: {
    // 更新state项
    setValue(state, data: any) {
      let createForm = { ...state[data.model] };
      // 从formInfo中提取字段和字段数据
      for (const key in data.formInfo) {
        if (key === data.field) {
          createForm[key] = data.value;
        } else {
          createForm[key] = data.formInfo[key];
        }
      }
      // 更新state数据
      state[data.model] = createForm;
      console.log("state", state);
      console.log("createForm", createForm);
      return {
        ...state
      };
    },

    setFieldValue(state, data: any) {
      const { field, value } = data
      console.warn(data)
      return update(state, {
        formDemo1: { [field]: { $set: value } }
      })
    },
    // 重置model中的数据
    resetModel(state, modelInfo: any) {
      //      const model = state[modelInfo.modelName];

      // if (model) {
      //   for (const item in model) {
      //     // 设置默认值
      //     switch (Object.getPrototypeOf(model[item]).constructor.name) {
      //       case "Array":
      //         model[item] = [];
      //         break;
      //       case "string":
      //       default:
      //         model[item] = "";
      //         break;
      //     }
      //   }
      // }
      //debugger;
      state[modelInfo.modelName] = { ...new Model[modelInfo.model]() };
      return { ...state };
    },
    // 重置指定字段的数据
    resetFieldsValue(state, modelInfo: any) {
      //debugger;
      for (const item of modelInfo.fields) {
        try {
          const assField = Model[modelInfo.model].mapToAssociatedField(item);

          const data = state[modelInfo.modelName];
          if (assField) {
            for (const field of assField) {
              data[field] = "";
            }
          } else {
            data[item] = "";
          }
        } catch (error) {
          console.warn(error);
        }
      }
      return { ...state };
    },
    // 根据提供的模型创建state
    addModel(state, data: any) {
      //debugger;
      state[data.modelName] = data.model;
      return { ...state };
    }
  }
};
